import moment from 'moment';
import { formatToDateTamplate } from './dateFormater';

export const getToday = () => formatToDateTamplate(moment());
